import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const Doctors = () => {
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    api.get("/doctors").then((r) => setDoctors(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="doctors-page">
      <section className="px-6 md:px-12 lg:px-20 pt-24 pb-16 md:pt-32">
        <p className="overline mb-6">Our Vaidyas</p>
        <h1 className="text-5xl sm:text-7xl tracking-tight font-light max-w-4xl leading-[1.05]">
          The hands and minds <em className="font-display italic" style={{ color: "var(--ayu-secondary)" }}>behind the practice.</em>
        </h1>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
          {doctors.map((d) => (
            <article key={d.id} data-testid={`doctor-${d.id}`} className="grid grid-cols-12 gap-6">
              <div className="col-span-5">
                <img src={d.image} alt={d.name} className="w-full aspect-[3/4] object-cover" loading="lazy" />
              </div>
              <div className="col-span-7">
                <p className="overline mb-3">{d.experience_years} years</p>
                <h3 className="font-display text-3xl mb-1">{d.name}</h3>
                <p className="text-sm mb-2" style={{ color: "var(--ayu-secondary)" }}>{d.title}</p>
                <p className="text-xs uppercase tracking-wider mb-5 opacity-70">{d.specialization}</p>
                <p className="text-sm leading-relaxed" style={{ color: "var(--ayu-body)" }}>{d.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-20 py-20 text-center" style={{ background: "var(--ayu-surface)" }}>
        <h2 className="font-display text-3xl sm:text-4xl mb-8">Book a consultation</h2>
        <Link to="/contact" data-testid="doctors-cta" className="btn-primary">Schedule a visit</Link>
      </section>
    </div>
  );
};

export default Doctors;
